import { FormControl } from '@mui/material';
import {
  FieldValues,
  FieldPath,
  useController,
} from 'react-hook-form';
import { TDatePickerControllerProps } from '../controllerTypes';
import CustomDatePicker from '../../../components/CustomDatePicker';

export function DatePickerController<
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  required,
  placeholder = `Select ${label?.toLowerCase()}`,
  error,
  disabled,
  onVisibleMonthChange,
  ...restProps
}: TDatePickerControllerProps<TFieldValues, TFieldName> & {
  onVisibleMonthChange?: (date: Date) => void;
}) {
  const { field } = useController({
    name,
    control,
    disabled,
  });

  return (
    <FormControl
      fullWidth
      className="h-28 form-control_autocomplete">
      {label && (
        <label className="form-field-label mt-[10px]">
          {label}
          {required && <i className="required">*</i>}
        </label>
      )}
      <CustomDatePicker
        {...restProps}
        {...field}
        ref={(ref) => {
          field.ref({
            focus: ref?.setFocus,
          });
        }}
        selected={field.value}
        className="w-full"
        placeholderText={placeholder}
        autoComplete="off"
        onFocus={(e) => (e.target.readOnly = true)}
        onVisibleMonthChange={onVisibleMonthChange}
      />
      {error && (
        <p className="form-field-error">
          {error?.toString()}
        </p>
      )}
    </FormControl>
  );
}
